import { ActionsUnion } from "common/reducers/UtilsTypes";
import { createAction } from "common/reducers/Utils";
import { IJobStateLogData } from "common/records/JobStateLog";

export const RECEIVE_JOB_STATE_LOG = "@jobStateLogs/RECEIVE_JOB_STATE_LOG";
export const RECEIVE_JOB_STATE_LOGS = "@jobStateLogs/RECEIVE_JOB_STATE_LOGS";

export const JobStateLogActions = {
  receiveJobStateLog: (stateLog: Partial<IJobStateLogData>) =>
    createAction("@jobStateLogs/RECEIVE_JOB_STATE_LOG", { stateLog }),
  receiveJobStateLogs: (stateLogs: Partial<IJobStateLogData>[]) =>
    createAction("@jobStateLogs/RECEIVE_JOB_STATE_LOGS", { stateLogs }),
};

export type JobStateLogActions = ActionsUnion<typeof JobStateLogActions>;
